import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

type DrawerDestination =
  | "learn"
  | "stats"
  | "decks"
  | "browse"
  | "search"
  | "cookbook";

function useNavigator() {
  return useCallback(
    (destination: DrawerDestination) => ({
      href: { pathname: `/(nav)/(app)/${destination}` as const },
      // Shell destinations load inside their own boundaries. Switching the drawer must stay
      // immediate even when a destination has no cached data or the device is offline.
      queries: [],
    }),
    [],
  );
}

export const useDrawerDestinationPageNavigator = createPageNavigator<DrawerDestination>({
  useNavigator,
});
